import { withScope, captureMessage } from '@sentry/react';

import { useSearchStore, sentryState } from '@/store/SearchStore';

export const getCurrentPosition = () =>
  new Promise<GeolocationPosition | undefined>((resolve) =>
    navigator.geolocation.getCurrentPosition(resolve, (error: GeolocationPositionError) => {
      const reasonFromCode = {
        1: 'Location sharing is turned off. Turn on location sharing in your device or browser settings, or enter a location to continue.',
        2: 'We cannot find your current location. Enter a location to continue.',
        3: 'Timeout while trying to get your current location. Please try again.',
      };
      const errorMessage =
        reasonFromCode?.[error?.code as keyof typeof reasonFromCode] ||
        error.message ||
        `Error getting your location: ${error}`;
      useSearchStore.getState().setError(errorMessage);
      withScope((scope) => {
        scope.setContext('search state', sentryState());
        scope.setContext('Geolocation Error', {
          message: errorMessage,
          error: JSON.stringify(error),
        });
        captureMessage('Unable to get current position (geolocation)', {
          level: 'info', // Does not send notifications
        });
      });
      resolve(undefined);
    }),
  );

export const watchPosition = (positionCallback: (position: GeolocationPosition) => void) =>
  navigator.geolocation.watchPosition(
    positionCallback,
    (error) => {
      const { selectedRoute, setError } = useSearchStore.getState();
      if (selectedRoute) {
        setError(`Error watching your current location: ${error.message}`);
      }
    },
    {
      enableHighAccuracy: true,
      timeout: 30000,
      maximumAge: 10000,
    },
  );
